import React from 'react';
import BootstrapRow from "ui/BootstrapRow";
import BootstrapCol from "ui/BootstrapCol";
import FieldsetContainer from "root/Base/FieldsetContainer";

import { FormInputCheckbox, FormInputDatePicker }  from "../../../ReactHookForm/FormComponents";

const HookSubFormStarFunding = ({control, register, watch, formErrors, sectionName, readOnly}) =>
{
    const hasStarFunding = watch(sectionName + '.top_up_funding_flag')

    return (
        <FieldsetContainer title='Star Funding' noborder={true}>
            <BootstrapRow>
                <BootstrapCol width={12}>
                    <FormInputCheckbox readOnly={readOnly} label='Does the pupil receive STAR funding?' sectionName={sectionName} name={'top_up_funding_flag'} register={register}/>
                </BootstrapCol>
            </BootstrapRow>

            { hasStarFunding === true && <BootstrapRow>
                 <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='STAR Funding Start Date' sectionName={sectionName} name={'funding_start_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
                <BootstrapCol width={6}>
                    <FormInputDatePicker readOnly={readOnly} label='STAR Funding End Date' sectionName={sectionName} name={'funding_end_date'} control={control} required={true} formErrors={formErrors}/>
                </BootstrapCol>
            </BootstrapRow> }
        </FieldsetContainer>
    )
}


export default HookSubFormStarFunding;
